import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

if (!(dayjs as any)._tz_extended) {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    (dayjs as any)._tz_extended = true;
}

export const MOLDOVA_TIMEZONE = "Europe/Chisinau";
export const CHICAGO_TIMEZONE = "America/Chicago";

export default dayjs;